<div class="icons" *transloco="let t">
  @if (actionOptions.delete) {
  <xt-portal-button
    [icon]="'delete'"
    [color]="'none'"
    [width]="'small'"
    [ariaLabel]="t('app.actions.delete')"
    [xTentionDummyCypress]="dataCy + '.delete'"
    (clickEvent)="delete()"
  />
  } @if (actionOptions.edit) {
  <xt-portal-button
    [icon]="'edit'"
    [color]="'none'"
    [width]="'small'"
    [ariaLabel]="t('app.actions.edit')"
    [xTentionDummyCypress]="dataCy + '.edit'"
    (clickEvent)="edit()"
  />
  } @if (actionOptions.download) {
  <xt-portal-button
    [icon]="'download'"
    [color]="'none'"
    [width]="'small'"
    [ariaLabel]="t('app.actions.download')"
    [xTentionDummyCypress]="dataCy + '.download'"
    (clickEvent)="download()"
  />
  } @if (actionOptions.share) {
  <xt-portal-button
    [icon]="'share'"
    [color]="'none'"
    [width]="'small'"
    [ariaLabel]="t('app.actions.share')"
    [disabled]="!(isShareActionEnabled$ | async)"
    [class]="{ 'is-disabled': !(isShareActionEnabled$ | async) }"
    [xTentionDummyCypress]="dataCy + '.share'"
    [xTentionDummyTooltip]="shareActionTooltip$ | async"
    [xTentionDummyTooltipFixByClick]="true"
    (clickEvent)="share()"
  />
  } @for (a of actionBarActionsList ?? []; track a.label) {
  <xt-portal-button
    [color]="'none'"
    [width]="'small'"
    [ariaLabel]="t('app.actions.' + a.icon)"
    [icon]="a.icon"
    [disabled]="a.methodName === 'share' && !(isShareActionEnabled$ | async)"
    [class]="{
      'is-disabled':
        a.methodName === 'share' && !(isShareActionEnabled$ | async)
    }"
    [xTentionDummyCypress]="dataCy + '.spec.' + a.methodName"
    [xTentionDummyTooltip]="
      a.methodName === 'share' && (shareActionTooltip$ | async)
    "
    [xTentionDummyTooltipFixByClick]="true"
    (clickEvent)="action(a.methodName)"
  />
  }
</div>
